import axios from "axios";
import * as Constants from "../constant";

const setUserProfile = async (formData) => {
	try {
		const response = await axios.post(
			`${Constants?.LOCAL_URL}/addresses`,
			formData
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
export default setUserProfile;
